/*
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Single Application / Multi Application License.
 * See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of purchased license.
 */

import { Component, Input, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
    selector: 'ngx-validation-message',
    styleUrls: ['./validation-message.component.scss'],
    template: `
             <p class="caption status-danger"
                *ngIf="showMinLength"> Longitud de {{ label }} Min is {{ minLength }} caracteres </p>
             <p class="caption status-danger"
                *ngIf="showMaxLength"> Longitud de {{ label }} Max es {{ maxLength }} caracteres </p>
             <p class="caption status-danger" *ngIf="showPattern"> Incorrecto {{ label }} </p>
             <p class="caption status-danger" *ngIf="showRequired"> {{ label }} es requerido</p>
             <p class="caption status-danger" *ngIf="showMin">El valor min de {{ label }} es {{ min }}</p>
             <p class="caption status-danger" *ngIf="showMax">El valor max de {{ label }} es {{ max }}</p>
  `,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => NgxValidationMessageComponent),
            multi: true,
        },
    ],
})
export class NgxValidationMessageComponent {
    @Input()
    label: string = '';

    @Input()
    showRequired?: boolean;

    @Input()
    min?: number;

    @Input()
    showMin?: boolean;

    @Input()
    max?: number;

    @Input()
    showMax: boolean;

    @Input()
    minLength?: number;

    @Input()
    showMinLength?: boolean;

    @Input()
    maxLength?: number;

    @Input()
    showMaxLength?: boolean;

    @Input()
    showPattern?: boolean;
}
